type Tone = 'accent' | 'primary' | 'secondary';

interface StatCardProps {
  label: string;
  value: string;
  caption?: string;
  icon?: string;
  tone?: Tone;
}

const toneStyles: Record<Tone, { bubble: string; value: string }> = {
  accent: { bubble: 'bg-accent-100 text-accent-800', value: 'text-accent-700' },
  primary: { bubble: 'bg-primary-100 text-primary-700', value: 'text-primary-700' },
  secondary: { bubble: 'bg-secondary-100 text-secondary-800', value: 'text-foreground-900' },
};

export default function StatCard({ label, value, caption, icon, tone = 'primary' }: StatCardProps) {
  const styles = toneStyles[tone];

  return (
    <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 hover:border-accent-300 transition-colors duration-200">
      <div className="flex items-center justify-between gap-3">
        <span className="flex min-h-[1.5rem] items-center text-xs md:text-sm font-medium text-foreground-600">{label}</span>
        {icon ? (
          <span className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-lg ${styles.bubble}`}>
            <i className={`${icon} text-base`} aria-hidden="true"></i>
          </span>
        ) : null}
      </div>
      <p className={`mt-3 font-num text-2xl md:text-3xl font-bold tracking-tight ${styles.value}`}>{value}</p>
      {caption ? (
        <p className="mt-auto min-h-[2rem] pt-1.5 text-xs leading-snug text-foreground-500">{caption}</p>
      ) : null}
    </div>
  );
}